import { GroupSidebarTabType } from '../../models/group-sidebar';

export type ApiGroupModel = {
    id: string;
    name: string;
    parent_id: string;
    subgroups: ApiGroupModel[];
    role?: any;
};

class GroupSidebarController {
    static $inject = ['$rootScope'];

    public active: GroupSidebarTabType = 'joined';

    constructor(private rootScope: angular.IRootScopeService) {
        rootScope.$on('group-sidebar-active-changed', (event, active: GroupSidebarTabType) => {
            this.active = active;
        });
    }
}

angular.module('tradersyard').component('tyGroupSidebar', {
    template: `

<div class="group_sidebar">
    <ty-group-sidebar-groups ng-if="$ctrl.active === 'joined'" add-button="true" filter-type="'joined'"/>
    <ty-group-sidebar-groups ng-if="$ctrl.active === 'own'" add-button="true" filter-type="'own'"/>
    <ty-group-sidebar-groups ng-if="$ctrl.active === 'top'" flatlist="true" add-button="false" filter-type="'top'"/>
</div>
    `,
    controller: GroupSidebarController,
});
